// extracted by mini-css-extract-plugin
export default {"rootClassName":"contrato-ente-publico-download-checklists-card"};